import { DataPath } from '../../DataPath';
import { ParseNode } from '../../Parse/ParseNode';
import { ExprCall } from '../ExprCall';
import { ExprForm } from '../ExprForm';
import { ExprPath } from '../ExprPath';
import { Generic } from './Generic';
export var Aggregate;
(function (Aggregate) {
    function matches(root) {
        if (root.type === "CallExpression") {
            if (root.arguments.length === 1 &&
                ParseNode.isAccess(root.arguments[0])) {
                return ExprCall.Name.isKnown(root.callee);
            }
        }
        return false;
    }
    Aggregate.matches = matches;
    function equals(left, right) {
        return left.name === right.name;
    }
    Aggregate.equals = equals;
    function parse(root) {
        if (root.type === "CallExpression") {
            const [accessNode] = root.arguments;
            if (accessNode != null) {
                switch (accessNode.type) {
                    case "Identifier":
                    case "AccessIdentifier":
                    case "AccessExpression": {
                        const call = ExprCall.Name.make(root.callee);
                        const path = ExprPath.fromParseNode(accessNode);
                        if (path.type !== "EMPTY") {
                            return Parsed.make(root, call, path);
                        }
                    }
                }
            }
        }
        return Generic.Parsed.make(root);
    }
    Aggregate.parse = parse;
    let Parsed;
    (function (Parsed) {
        function make(root, call, path) {
            const form = ExprForm.Aggregate;
            const state = "PARSED";
            const name = `${call}(${DataPath.name(path)})`;
            return { root, path, call, state, form, name };
        }
        Parsed.make = make;
    })(Parsed = Aggregate.Parsed || (Aggregate.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(expr, stage, data) {
            return { ...expr, stage, data, state: "COMPILED" };
        }
        Compiled.make = make;
    })(Compiled = Aggregate.Compiled || (Aggregate.Compiled = {}));
})(Aggregate || (Aggregate = {}));
